/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramSummaryDto } from './program-summary-dto';


export interface AgencySummaryDto { 
    addressPhysicalCity?: string;
    addressPhysicalStateLookup?: string;
    addressPhysicalStreet?: string;
    addressPhysicalZip?: string;
    adminEmail?: string;
    adminFirstName?: string;
    adminLastName?: string;
    adminPhone?: string;
    agencyName?: string;
    agencyType?: AgencySummaryDto.AgencyTypeEnum;
    createdDate?: string;
    expiresDate?: string;
    id?: string;
    primaryContactEmail?: string;
    primaryContactFirstName?: string;
    primaryContactLastName?: string;
    primaryContactPhone?: string;
    programs?: Array<ProgramSummaryDto>;
    status?: string;
    testAgency?: boolean;
}
export namespace AgencySummaryDto {
    export const AgencyTypeEnum = {
        Private: 'PRIVATE',
        Public: 'PUBLIC'
    } as const;
    export type AgencyTypeEnum = typeof AgencyTypeEnum[keyof typeof AgencyTypeEnum];
}


